export const invitation404FormContentsEn = {
  header: `We couldn't find your Invitation`,
  headerDescription: 'Sorry, something went wrong. Your invitation link may have expired or been cancelled.',
  contactUsDescription: 'If you have any questions, please reach out to us at',
}

export const invitation404FormContentsKr = {
  header: '초대 내역을 찾을 수 없습니다',
  headerDescription: '죄송합니다. 초대 링크가 만료되었거나 취소되어 초대를 수락할 수 없습니다.',
  contactUsDescription: '어웨어 제품/이용 문의는 이메일로 연락주세요. ',
}